// Depois (React 18)
import { createRoot } from 'react-dom/client';
import App from './App'; // Seu componente principal
import { pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.mjs`;

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(<App />);
}